import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const EditorR3FillIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 6L19.5 9.5L16 13"
        stroke={fillColor || "white"}
        strokeLinejoin="round"
      />
      <path
        d="M19 9.5H7.25C5.45507 9.5 4 10.9551 4 12.75V12.75C4 14.5449 5.45507 16 7.25 16H13"
        stroke={fillColor || "white"}
      />
    </svg>
  );
};

export { EditorR3FillIcon };
